var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.name === 'home')?_c('extended-toolbar'):_c('app-toolbar'),(_vm.$vuetify.breakpoint.xsOnly)?_c('app-drawer'):_vm._e(),_c('v-content',[_c('router-view')],1),_c('app-footer'),_c('app-overlays')],1)}
var staticRenderFns = []

export { render, staticRenderFns }